import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styles from './Reviews.module.scss';
import { LocationDetailsResponseType, PageFilterType } from '@/types/locationDetailsPages/shared';

const getFilterStringFromUid = (uid: PageFilterType, locationName: string): ReactNode => {
  // currently only en-US; will need to be translate & locationName broken out based on type if SEO test is rolled out
  const filterPrefix = {
    backpacking: 'Backpacking trail reviews',
    'bike-touring': 'Bike touring trail reviews',
    birding: 'Birding trail reviews',
    camping: 'Camping trail reviews',
    'cross-country-skiing': 'Cross-country skiing trail reviews',
    fishing: 'Fishing trail reviews',
    'horseback-riding': 'Horseback riding trail reviews',
    'mountain-biking': 'Mountain biking trail reviews',
    'off-road-driving': 'Off-road driving trail reviews',
    'paddle-sports': 'Paddle sports trail reviews',
    'road-biking': 'Road biking trail reviews',
    'rock-climbing': 'Rock climbing trail reviews',
    'scenic-driving': 'Scenic driving trail reviews',
    skiing: 'Skiing trail reviews',
    snowshoeing: 'Snowshoeing trail reviews',
    'trail-running': 'Running trail reviews',
    'via-ferrata': 'Via ferrata trail reviews',
    walking: 'Walking trail reviews',
    ada: 'Wheelchair-friendly trail reviews',
    beach: 'Beach trail reviews',
    cave: 'Cave trail reviews',
    'city-walk': 'City walk reviews',
    'no-dogs': 'No dogs allowed trail reviews',
    dogs: 'Dog friendly trail reviews',
    'dogs-leash': 'Dogs on leash trail reviews',
    est: 'Forest trail reviews',
    'historic-site': 'Historic site trail reviews',
    'hot-springs': 'Hot springs trail reviews',
    kids: 'Kid friendly trail reviews',
    lake: 'Lake trail reviews',
    'partially-paved': 'Partially paved trail reviews',
    paved: 'Paved trail reviews',
    'rails-trails': 'Rail trail reviews',
    river: 'River trail reviews',
    strollers: 'Stroller-friendly trail reviews',
    views: 'Scenic viewpoint trail reviews',
    waterfall: 'Waterfall trail reviews',
    'wild-flowers': 'Wildflower trail reviews',
    wildlife: 'Wildlife trail reviews',
    easy: 'Easy trail reviews',
    moderate: 'Moderate trail reviews',
    hard: 'Hard trail reviews',
    short: 'Short trail reviews',
    long: 'Long trail reviews'
  }[uid];

  return (
    <>
      {filterPrefix} for <span className={styles.secondaryText}>{locationName}</span>
    </>
  );
};

type ReviewTitleProps = {
  locationName: string;
  type: LocationDetailsResponseType;
  pageFilterUid?: PageFilterType;
  seoTestActivityInTitle?: boolean;
};

export const ReviewTitle = ({ locationName, type, pageFilterUid, seoTestActivityInTitle }: ReviewTitleProps) => {
  const intl = useIntl();
  if (seoTestActivityInTitle && pageFilterUid) {
    return getFilterStringFromUid(pageFilterUid, locationName);
  }

  if (type === 'park') return intl.formatMessage({ defaultMessage: 'Trail reviews for {parkName}' }, { parkName: locationName });
  if (type === 'poi') return intl.formatMessage({ defaultMessage: 'Trail reviews for {poiName}' }, { poiName: locationName });
  if (type === 'country') return intl.formatMessage({ defaultMessage: 'Trail reviews for {countryName}' }, { countryName: locationName });
  if (type === 'state') return intl.formatMessage({ defaultMessage: 'Trail reviews for {stateName}' }, { stateName: locationName });
  if (type === 'city') return intl.formatMessage({ defaultMessage: 'Trail reviews for {cityName}' }, { cityName: locationName });

  return intl.formatMessage({ defaultMessage: 'Trail reviews' });
};
